import { Button } from '@app/components/various/Button';
import { Account, ChevronLeft, DeselectAll, Inventory, Reset } from '@app/components/various/Icons';
import { Skeleton } from '@app/components/various/Skeleton';
import { AccountRequestStatus } from '@app/constants/requests';
import { isDefined } from '@app/utils/is';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface Props {
  status?: AccountRequestStatus;
  isLoading: boolean;
  isLoadingStatus: boolean;
  previousPath: Location | string;
  goToAccount: VoidFunction;
  onDecline: VoidFunction;
  onCreateAccount: VoidFunction;
  onArchive?: VoidFunction;
  onPending?: VoidFunction;
}

export const AccountRequestHeaderActionButtonsMobile = ({
  status,
  isLoading,
  isLoadingStatus,
  previousPath,
  goToAccount,
  onCreateAccount,
  onDecline,
  onArchive,
  onPending,
}: Props) => {
  const { t } = useTranslation(['requests']);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center gap-2">
        <Skeleton type="button" size="medium" />
        <Skeleton type="button" size="medium" />
        <Skeleton type="button" size="medium" />
      </div>
    );
  }

  const isPending = isDefined(status) && status === AccountRequestStatus.Pending;
  const isDeclined = isDefined(status) && status === AccountRequestStatus.Declined;
  const isAccepted = isDefined(status) && status === AccountRequestStatus.Accepted;

  return (
    <div className="flex items-center justify-center gap-2">
      {(isDeclined || isAccepted) && (
        <Button
          variant="text"
          color="secondary"
          size="medium"
          className="shrink-0"
          onClick={onArchive}
          disabled={isLoadingStatus}
          icon={Inventory}
        />
      )}
      <Button
        as={Link}
        to={previousPath}
        variant="bordered"
        color="secondary"
        className="shrink-0"
        disabled={isLoadingStatus}
        icon={ChevronLeft}
        size="medium"
      />
      {isPending && (
        <Button color="secondary" size="medium" className="shrink-0" onClick={onDecline} disabled={isLoadingStatus} icon={DeselectAll} />
      )}
      {isPending && <Button className="shrink-0" size="medium" onClick={onCreateAccount} disabled={isLoadingStatus} icon={Account} />}
      {isDeclined && <Button className="shrink-0" size="medium" onClick={onPending} disabled={isLoadingStatus} icon={Reset} />}
      {isAccepted && (
        <Button className="shrink-0" size="medium" onClick={goToAccount} disabled={isLoadingStatus} icon={Account}>
          {t('requests:view')}
        </Button>
      )}
    </div>
  );
};
